import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import s from './backgroundImage.module.css';

export const mapStateToProps = ({
  language,
}) => ({
  desktopImageLink: language['returns.validate.background_image_link'],
  mobileImageLink: language['returns.validate.background_image_link_mobile'] || language['returns.validate.background_image_link'],
});

const BackgroundImage = ({ desktopImageLink, mobileImageLink }) => (
  <Fragment>
    <div style={{ backgroundImage: `url(${desktopImageLink})` }} className={`${s.image_desktop} desktop-background`} />
    <div style={{ backgroundImage: `url(${mobileImageLink})` }}  className={`${s.image_mobile} mobile-background`} />
  </Fragment>
);

BackgroundImage.propTypes = {
  desktopImageLink: PropTypes.string.isRequired,
  mobileImageLink: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(BackgroundImage);
